import { useAtom } from "jotai";
import { useState } from "react";
import toast from "react-hot-toast";
import axiosInstance from "helpers/api";
import { useForm } from "react-hook-form";
import { UserInfo } from "interfaces/user";
import { user_info } from "jotai/UserJotaiInstance";
import { Button, Col, Form, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

type FormData = {
  new_password: string
  confirm_password: string
  current_password: string
};

const Security = () => {
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
      } = useForm<FormData>();
    const [userInfo] = useAtom<UserInfo>(user_info);
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false)
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)
    const [showCurrentPassword, setShowCurrentPassword] = useState(false)
    
    const handleUpdateProfile = (data: FormData) => {
        setLoading(true);
        axiosInstance.patch(`/users/${userInfo.id}/password`, {
            current_password: data.current_password,
            new_password: data.new_password,
            confirm_password: data.confirm_password
        }).then(res => {
            toast.success(res.data.message);
            reset();
        }).catch(error => {
            toast.error(error.response.data.message)
        }).finally(() => {
            setLoading(false);
        })
    }

    return (
        <div>
            <h4 className="mb-4">Change your password</h4>
            <form onSubmit={handleSubmit(handleUpdateProfile)}>
                <Row className="g-3">
                    <Col lg={6}>
                        <Form.Group>
                            <Form.Label>
                                Current Password <span className="text-danger"> *</span>
                            </Form.Label>
                            <div style={{ position: "relative" }}>
                                <Form.Control
                                    {...register("current_password", {
                                        required: "Current password is required",
                                    })}
                                    type={showCurrentPassword ? "text" : "password"}
                                    placeholder="Enter your current password"
                                    isInvalid={!!errors.current_password}
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowCurrentPassword((prev) => !prev)}
                                    className="btn btn-link p-0 position-absolute end-0 translate-middle-y me-2"
                                    style={{ textDecoration: "none", top: "54%" }}
                                >
                                    <FontAwesomeIcon icon={showCurrentPassword ? faEyeSlash : faEye} />
                                </button>
                                <Form.Control.Feedback type="invalid">
                                    {errors.current_password?.message}
                                </Form.Control.Feedback>
                            </div>
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>
                                New Password <span className="text-danger"> *</span>
                            </Form.Label>
                            <div style={{ position: "relative" }}>
                                <Form.Control
                                    autoComplete="new-password"
                                    {...register("new_password", {
                                        required: "New password is required",
                                        minLength: {
                                            value: 8,
                                            message: "Password must be at least 8 characters long.",
                                        },
                                        maxLength: {
                                            value: 40,
                                            message: "Password cannot exceed 40 characters.",
                                        },
                                    })}
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Enter your new password"
                                    isInvalid={!!errors.new_password}
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword((prev) => !prev)}
                                    className="btn btn-link p-0 position-absolute end-0 translate-middle-y me-2"
                                    style={{ textDecoration: "none", top: "54%" }}
                                >
                                    <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                                </button>
                                <Form.Control.Feedback type="invalid">
                                    {errors.new_password?.message}
                                </Form.Control.Feedback>
                            </div>
 
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>
                                Confirm Password <span className="text-danger"> *</span>
                            </Form.Label>
                            <div style={{ position: "relative" }}>
                            <Form.Control
                                autoComplete="new-password"
                                {...register("confirm_password", {
                                    required: "Confirm password is required",
                                })}
                                type={showConfirmPassword ? "text" : "password"}
                                placeholder="Enter your new password"
                                isInvalid={!!errors.confirm_password}
                            />
                            <button
                                type="button"
                                onClick={() => setShowConfirmPassword((prev) => !prev)}
                                className="btn btn-link p-0 position-absolute end-0 translate-middle-y me-2"
                                style={{ textDecoration: "none", top: "54%" }}
                            >
                                <FontAwesomeIcon icon={showConfirmPassword ? faEyeSlash : faEye} />
                            </button>
                            <Form.Control.Feedback type="invalid">
                                {errors.confirm_password?.message}
                            </Form.Control.Feedback>
                            </div>
    
                        </Form.Group>

                        <div className="d-flex mt-4">
                            <Button
                            variant="primary"
                            type="submit"
                            disabled={loading}
                            >
                                Change Password
                            </Button>
                        </div>
                    </Col>
                </Row>
            </form>
        </div>
    )
}

export default Security;